import { render, staticRenderFns } from "./VantSameSelectPop.vue?vue&type=template&id=06232082&"
import script from "./VantSameSelectPop.vue?vue&type=script&lang=js&"
export * from "./VantSameSelectPop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports